<!-- 上课点评 -->
<template>
  <div class="yunxiao teacher course-comment-edit flex-between" data-test="course-comment-edit">
    <div class="main-container">
      <!-- <div class="aiGrowth" @click="detailIntroduce">
        <span>AI成长粒上线啦！自动生成学员相册与作品集</span>
        <i class="van-icon van-icon-arrow"></i>
      </div> -->
      <div class="title">
        正在对{{ stusName }}&nbsp;{{ stus.length > 2 ? stus.length + '名学员' : '' }}进行点评
        <span class="preview" @click="toPreview">预览</span>
      </div>
      <div class="class-time" v-if="detail">
        {{ detail.classTime.date | formatDatetime(new Date(detail.classTime.date).getFullYear()===new Date().getFullYear()?'MM月dd日 hh:mm':'yyyy年MM月dd日 hh:mm') }}（{{ detail.classTime.weekdayName }}）
        {{ detail.classTime.startTime }}-{{ detail.classTime.endTime }}
      </div>
      <div class="van-ellipsis">
        <span class="l2">
          {{ detail && detail.curriculumName }}
        </span>
        <span class="l2" v-show="detail && detail.className"> · {{ detail && detail.className }} </span>
      </div>
      <van-divider style="margin:8px 0;" />
      <div class="every-switch" v-if="stus.length > 1">
        <span>逐个点评</span>
        <van-switch v-model="isEveryComment" active-color="var(--c1)" size="24px" />
      </div>
      <!-- <div class="students">
        <div v-for="item in students" :key="item.id" class="student-item"></div>
      </div> -->
      <van-tabs
        :line-height="0"
        :ellipsis="false"
        v-if="stus.length > 1"
        class="students-tab"
        @change="tabsChange"
        :style="!isEveryComment ? 'height:0px;opacity:0' : ''"
      >
        <van-tab v-for="(item, index) in stus" :key="item.studentId" :name="item.studentId">
          <template #title>
            <div class="student-name">
              {{ item.studentName }}
              <div
                class="point"
                v-show="
                  item.studentId !== currentStudentId &&
                    params.itemList[index] &&
                    params.itemList[index].commentScore.score > 0 &&
                    params.itemList[index].commentContent.list.some(
                      v =>
                        (['text', 'aitext'].includes(v.type) && v.content.trim() !== '') ||
                        ['image', 'video', 'audio'].includes(v.type)
                    )
                "
              ></div>
            </div>
          </template>
        </van-tab>
      </van-tabs>
      <van-form input-align="right" class="comment-form">
        <van-field
          name="radio"
          v-if="!isEveryComment"
          label-class="abc"
          label="表现评分"
          style="padding-bottom: 0px;padding-top:8px"
        >
          <template #input>
            <div>
              <van-rate
                v-model="params.item.commentScore.score"
                void-icon="star"
                size="var(--fs-ex2)"
                void-color="var(--g4)"
                color="var(--c4)"
              />
            </div>
          </template>
        </van-field>
        <van-field
          name="radio"
          v-if="isEveryComment"
          label-class="abc"
          label="表现评分"
          style="padding-bottom: 0px;padding-top:8px"
        >
          <template #input>
            <div>
              <van-rate
                v-model="params.itemList[currentStudentIndex].commentScore.score"
                void-icon="star"
                size="var(--fs-ex2)"
                void-color="var(--g4)"
                color="var(--c4)"
              />
            </div>
          </template>
        </van-field>
        <!-- <van-divider style="margin:8px 0;"/> -->
        <div class="comment-title">
          <van-field
            v-model="params.item.commentTitle"
            class="text"
            input-align="left"
            :maxlength="50"
            placeholder="请输入"
            v-if="!isEveryComment"
          />
          <van-field
            v-else
            :maxlength="50"
            v-model="params.itemList[currentStudentIndex].commentTitle"
            class="text"
            input-align="left"
            placeholder="请输入"
          />
        </div>

        <van-field style="display: block;padding-top: 0px;" v-if="!isEveryComment">
          <!-- <template #label>
            <span>课堂评价</span>
          </template> -->
          <template #input>
            <vx-mult-input
              v-model="params.item.commentContent.list"
              :showText="true"
              :enableText="false"
              enableAiText
              enableAudio
              enableVideo
              :aiTextPlaceholder="
                '您可以按照自己的想法 🧐🤔 输入一段课堂评语 📝，尽量包含学员信息 👨🏻‍🎓👩🏻‍🎓 、上课信息及课堂表现。然后根据需要，通过AI的文字能力实现纠正错别字及排版 🔍，或者进行文案的润色、扩写、精简，同时可以选择生成生成内容的语气、大概的字数和是否包含表情。🎉☀😋'
              "
              ref="multInputRef"
              :aiRemaining="aiRemaining"
              :tokenWarn="tokenWarn"
              :remainTokenNum="remainTokenNum"
              @getTokenUsageApi_init="getTokenUsageApi_init"
            >
              <template v-slot:moment v-if="openMOMENT">
                <div class="tool" @click="addMoments">
                  <svg class="vxm-icon" aria-hidden="true">
                    <use xlink:href="#vxm-icon-a-Maskgroup"></use>
                  </svg>
                  <div class="text">精彩瞬间</div>
                </div>
              </template>
            </vx-mult-input>
          </template>
        </van-field>
        <van-field style="display: block;padding-top: 0px;" v-if="isEveryComment">
          <!-- <template #label>
            <span>课堂评价</span>
          </template> -->
          <template #input>
            <vx-mult-input
              v-model="params.itemList[currentStudentIndex].commentContent.list"
              :showText="true"
              :enableText="false"
              enableAiText
              enableAudio
              enableVideo
              :aiTextPlaceholder="
                '您可以按照自己的想法 🧐🤔 输入一段课堂评语 📝，尽量包含学员信息 👨🏻‍🎓👩🏻‍🎓 、上课信息及课堂表现。然后根据需要，通过AI的文字能力实现纠正错别字及排版 🔍，或者进行文案的润色、扩写、精简，同时可以选择生成生成内容的语气、大概的字数和是否包含表情。🎉☀😋'
              "
              ref="multInputRef"
              :aiRemaining="aiRemaining"
              :tokenWarn="tokenWarn"
              :remainTokenNum="remainTokenNum"
              @getTokenUsageApi_init="getTokenUsageApi_init"
            >
              <template v-slot:moment v-if="openMOMENT">
                <div class="tool" @click="addMoments">
                  <svg class="vxm-icon" aria-hidden="true">
                    <use xlink:href="#vxm-icon-a-Maskgroup"></use>
                  </svg>
                  <div class="text">精彩瞬间</div>
                </div>
              </template>
            </vx-mult-input>
          </template>
        </van-field>
      </van-form>

      <div class="qanda-wrapper flex-center" v-if="reviewEnable">
        家长回评：开启
        <van-popover
          class="icon"
          trigger="click"
          placement="bottom"
          theme="dark"
          :offset="[0, 4]"
          v-model="showTips"
        >
          家长可在收到点评后进行回评
          <template #reference>
            <van-icon name="question-o" class="tips-icon" />
          </template>
        </van-popover>
      </div>
      <!-- <div class="tips" v-if="isBatch">批量点评将覆盖选中的老师已点评内容</div> -->
    </div>
    <pageFooterBtn :multipleBtns="true">
      <template>
        <van-button
          v-if="isDraft"
          class="button-slot"
          square
          round
          type="default"
          @click="submitComment(0)"
          :loading="isSave"
          loading-text="保存中..."
        >
          保存草稿
        </van-button>
        <van-button
          class="button-slot"
          color="var(--c1)"
          square
          round
          type="primary"
          @click="submitComment(1)"
          :loading="isSubmit"
          loading-text="发布中..."
        >
          发布点评
        </van-button>
      </template>
    </pageFooterBtn>
    <van-action-sheet
      title="请选择视频类型"
      v-model="as1"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @select="selectAs1"
    />
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
export default {
  name: 'course-comment-edit',
  components: {
    pageFooterBtn,
  },
  data() {
    return {
      isEveryComment: false,
      everyCommentList: [],
      oneCommentList: [],
      students: [
      ],
      currentStudentId: '',
      currentStudentIndex: 0,
      pageTitle: '点评',
      isSubmit: false,
      isSave: false,
      isBatch: false,
      optype: 'add',
      detail: null,
      showTips: false,
      reviewEnable: 0,
      id: '',
      stus: [],
      params: {
        campusId: '',
        classId: '', //班级id(课堂点评必填)
        commentType: 0, //点评类型（0 课堂点评，1 学员点评）
        courseArrangeId: '', //排课id(课堂点评必填)
        curriculumId: '', //课程id
        studentIds: [], //学员ids(批量点评必填)
        item: {
          commentTitle: '',
          commentContent: {
            list: [
              {
                content: '',
                type: 'aitext',
              },
            ],
          },
          commentScore: {
            score: 0,
            scoreType: 0,
          },
        },
        itemList: [],
      },
      as1: false,
      isDraft: true,
      actions: [
        {
          type: 1,
          name: '合成视频',
        },
        {
          type: 2,
          name: '视频片段',
        },
      ],
      aiRemaining: false, //ai算力容量是否有剩余
      tokenWarn: false, //AI算力预警
      remainTokenNum: '', //AI算力剩余值
    };
  },
  computed: {
    ...Vuex.mapState(['userInfo']),
    openMOMENT() {
      return (
        app.tool
          .safeReadObjProp(this.userInfo, 'companyInfoVo.companyAppOpenList')
          .indexOf('MOMENT') > -1
      );
    },
    stusName() {
      let names = this.stus.map(v => v.studentName);
      if (names.length > 2) {
        return `${names[0]}、${names[1]}等`;
      } else {
        return names.join('、');
      }
    },
  },
  methods: {
    tabsChange(e) {
      this.currentStudentId = e;
      this.currentStudentIndex = this.stus.findIndex(s => s.studentId === e);
    },
    render() {
      this.showLoading();
      this.$api
        .commentDetail({
          commentId: this.id,
        })
        .then(res => {
          if (res.code === 200) {
            let d = res.data;
            this.detail = res.data;
            this.isDraft = !d.commentRecordStatus;
            (this.params.campusId = d.campusId),
              (this.params.classId = d.classId),
              (this.params.courseArrangeId = d.courseArrangeId),
              (this.params.curriculumId = d.curriculumId);
            this.params.item.commentContent = d.commentContent;
            this.params.item.commentScore.id = d.commentScoreId;
            this.params.item.commentScore.score = d.score;
            this.params.item.commentTitle = d.commentTitle;
            this.params.studentIds = [
              // {
              //   studentId: d.studentId,
              //   commentRecordId: d.id,
              // },
              d.studentId,
            ];
            this.stus = [d];
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    submitComment(type) {
      //批量操作：调用postComment接口，单个新增：调用postComment接口，单个修改：putComment接口
      // let _pro = this.optype == 'add' ? this.$api.postComment : this.$api.putComment;
      let _pro = this.$api.batchAddOrModify;
      // commentBatchAdd
      let cont = [];
      if (this.params.studentIds.length == 0) {
        this.$toast.fail('请选择点评学员');
        return;
      }
      if (this.isEveryComment) {
        // length大于0则存在没有选择课堂评分的
        let scoreList = this.params.itemList.filter(stu => {
          return stu.commentScore.score === 0;
        });
        if (scoreList.length && type !== 0) {
          // 课堂评分
          this.$toast.fail(this.isEveryComment?'还有未完成点评的学员':'请选择课堂评分');
          return;
        }

        // 获取filter之后的结果
        cont = this.params.itemList.filter(stu => {
          let flag = stu.commentContent.list.every(v => {
            return (
              (v.type == 'text' || v.type == 'aitext') &&
              v.content.trim() === '' &&
              !['image', 'video', 'audio'].includes(v.type)
            );
          });
          // 如果是保存草稿，要考虑标题也属于保存草稿范围
          if (type === 0) {
            return flag && stu.commentTitle === '';
          }
          return flag;
        });

        if (cont.length && type !== 0) {
          this.$toast.fail(this.isEveryComment?'还有未完成点评的学员':'请输入课堂评价');
          // 还有未输入课堂评价的学员
          return;
        }

        // 判读有没有使用精彩瞬间
        let everyCommentContent = this.params.itemList.filter(stu => {
          let flag = stu.commentContent.list.some(v => {
            return v.type === 'moment';
          });
          return flag;
        });
        if (type === 0 && everyCommentContent.length) {
          vant.Dialog.alert({
            message: `保存草稿不支持使用精彩瞬间的“一键生成/制作”功能。请返回修改`,
            confirmButtonText: '我知道了',
          });
          return;
        }

        if (
          type === 0 &&
          scoreList.length === this.params.itemList.length &&
          cont.length == this.params.itemList.length
        ) {
          this.$toast.fail('没有需要保存的草稿内容');
          return;
        }
      } else {
        cont = this.params.item.commentContent.list.filter(v => {
          return (
            ((v.type == 'text' || v.type == 'aitext') && v.content.trim() != '') ||
            ['image', 'video', 'audio'].includes(v.type)
          );
        });

        if (
          type === 0 &&
          this.params.item.commentScore.score == 0 &&
          this.params.item.commentTitle.trim() === '' &&
          cont.length == 0
        ) {
          this.$toast.fail('没有需要保存的草稿内容');
          return;
        }
        if (this.params.item.commentScore.score == 0 && type !== 0) {
          // 选择课堂评分
          this.$toast.fail(this.isEveryComment?'还有未完成点评的学员':'请选择课堂评分');
          return;
        }
        if (cont.length == 0 && type !== 0) {
          // 输入课堂评价
          this.$toast.fail(this.isEveryComment?'还有未完成点评的学员':'请输入课堂评价');
          return;
        }
        if (type === 0 && this.params.item.commentContent.list.some(v => v.type === 'moment')) {
          vant.Dialog.alert({
            message: `保存草稿不支持使用精彩瞬间的“一键生成/制作”功能。请返回修改`,
            confirmButtonText: '我知道了',
          });
          return;
        }
      }

      this.params.batchType = this.isEveryComment ? 2 : 1;
      // 保存类型，0草稿、 1发布
      this.params.commentRecordStatus = type;
      if (!type) {
        this.isSave = true;
      } else {
        this.isSubmit = true;
      }
      let requestParam = JSON.parse(JSON.stringify(this.params));
      if (this.isEveryComment) {
        requestParam.item = undefined;
        if (type === 0) {
          requestParam.itemList = requestParam.itemList.filter(v => {
            // console.log(v, '过滤');
            let flag = v.commentContent.list.some(v => {
              if (['aitext', 'text'].includes(v.type) && v.content.trim() !== '') {
                return true;
              } else if (['image', 'video', 'audio'].includes(v.type)) {
                return true;
              } else {
                return false;
              }
            });
            return (
              v.commentScore.score !== 0 ||
              flag ||
              v.commentTitle.trim() !== '' ||
              !!v.commentRecordId
            );
          });
          // console.log('需要保存草稿的list', requestParam.itemList);
        }
        requestParam.itemList = requestParam.itemList.map(v => {
            let objParent={...v};
            objParent.commentContent.list=objParent.commentContent.list.map(v=>{
              let obj={...v};
              obj.showPopover=undefined;
              obj.aiResults=undefined;
              obj.lastContent=undefined;
              obj.backText=undefined;
              obj.disabled=undefined;
              obj.showBack=undefined;
              return obj
            })
            return objParent
          });
      } else {
        requestParam.itemList = undefined;
        requestParam.item.commentContent.list=requestParam.item.commentContent.list.map(v=>{
          let obj={...v};
          obj.showPopover=undefined;
          obj.aiResults=undefined;
          obj.lastContent=undefined;
          obj.backText=undefined;
          obj.disabled=undefined;
          obj.showBack=undefined;
          return obj
        })
      }
      requestParam.commentType = undefined;
      requestParam.campusId = undefined;
      requestParam.classId = undefined;
      requestParam.curriculumId = undefined;
      // console.log(requestParam, '打印参数');
      _pro(requestParam)
        .then(res => {
          if (res.code == 200) {
            if (this.optype == 'edit') {
              app.vue.$emit('refresh-comment-detail');
            }
            app.vue.$emit('refresh-course-comment-list');
            app.vue.$emit('refresh-comment-student');
            // 存在合成中视频，提交点评，需弹出这个提示
            let momentArr = [];
            if (this.isEveryComment) {
            } else {
              momentArr = this.params.item.commentContent.list.filter(v => {
                return v.type == 'moment' && !v.url;
              });
            }

            if (momentArr.length > 0) {
              vant.Dialog.alert({
                title: '提交成功',
                message: `点评将在视频合成后自动发送`,
                confirmButtonText: '我知道了',
              }).then(() => {
                this.$router.back();
              });
            } else {
              this.$toast.success(`${this.optype == 'add' ? '新增' : '修改'}点评成功`);
              setTimeout(() => {
                this.$router.back();
              }, 50);
            }
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .finally(() => {
          // 谷歌分析按钮点击统计
          gtag('event', 'x3-event-button', {
            x3_env: process.env.VUE_APP_x3_env,
            x3_app_type: 'x3-老师端',
            x3_client_type: app.base.env,
            x3_company_name: app.teacher.user.companyInfoVo.companyName,
            x3_menu_name: type===0?'保存草稿':`发布点评`,
          });
          this.isSubmit = false;
          this.isSave = false;
        });
    },
    async addMoments() {
      let res = await this.$api.checkCourseArrangeVideo({
        courseArrangeId: this.params.courseArrangeId,
      });
      const { hasSetClassRoom, hasClassRoomBindCamera, hasClipVideo, hasVideo } = res.data;
      if (!hasSetClassRoom || !hasClassRoomBindCamera) {
        vant.Dialog.alert({
          message: `排课未设置教室，或教室未关联设备，无法获取精彩瞬间视频<br/><div style="margin-top: 12px;color: var(--g6);">关联设备需前往电脑端精彩瞬间页面去操作</div>`,
          confirmButtonText: '我知道了',
          allowHtml: true,
        });
        return;
      }
      if (!hasClipVideo) {
        vant.Dialog.alert({
          message: `没有这节课的进球视频`,
          confirmButtonText: '我知道了',
        });
        return;
      }
      if (!hasVideo) {
        // 跳转页面选择片段
        let path = `/comment-moments?campusId=${this.params.campusId}&courseArrangeId=${this.params.courseArrangeId}&type=2`;
        if (this.stus.length == 1 && this.stus[0].archivesId) {
          path += `&archivesId=${this.stus[0].archivesId}`;
        }

        this.$router.push(path);
      } else {
        this.as1 = true;
      }
    },
    selectAs1(action) {
      if (action.type == 1) {
        this.$router.push(
          `/comment-moments?campusId=${this.params.campusId}&courseArrangeId=${this.params.courseArrangeId}&type=1`
        );
      } else if (action.type == 2) {
        let path = `/comment-moments?campusId=${this.params.campusId}&courseArrangeId=${this.params.courseArrangeId}&type=2`;
        if (this.stus.length == 1 && this.stus[0].archivesId) {
          path += `&archivesId=${this.stus[0].archivesId}`;
        }

        this.$router.push(path);
      }
    },
    // 跳转预览，判断是逐个评价还是概评
    toPreview() {
      let detailJson = {
        className: this.detail.className,
        classTime: this.detail.classTime,
        createTime: this.detail.createTime || new Date().getTime(),
        commentRecordStatus: 1,
        curriculumName: this.detail.curriculumName,
        teacherName: this.detail.teacherName,
        coursePlanType: 0,
       };
     
      if (this.isEveryComment) {
        let stu = this.stus.find(v => v.studentId === this.currentStudentId);
        detailJson.studentId = this.currentStudentId;
        detailJson.studentName = stu.studentName;
        detailJson.studentSex = stu.studentSex;
        detailJson.score = this.params.itemList[this.currentStudentIndex].commentScore.score;
        detailJson.commentTitle=this.params.itemList[this.currentStudentIndex].commentTitle;
        detailJson.commentContent=this.params.itemList[this.currentStudentIndex].commentContent;
        // console.log('逐个');
      } else {
        detailJson.score = this.params.item.commentScore.score;
        detailJson.commentTitle=this.params.item.commentTitle;
        detailJson.commentContent=this.params.item.commentContent;
        if(this.stus.length===1){
          detailJson.studentId = this.stus[0].studentId;
          detailJson.studentName = this.stusName;
        }
        // console.log('yiqi ');
      }
      // console.log(detailJson);
      // console.log(this.detail,'detaui');

      app.ls.setStorage('comment-c-preview', JSON.stringify(detailJson));
      this.$router.push('/courseCommentPreview');
    },
    // 判断所有选择的学员信息是否一样，是则进入概括点评
    checkAllStus(){
      let list=this.stus.filter(v=>{
        let flag=true;
        if((!v.score&&!v.commentTitle&&(!v.commentContent||v.commentContent.length===0))||v.commentRecordStatus===null){
          flag=false;
        }
        return flag;
      })
      if(list.length>1){
        // 对比如果内容一样，返回false，不一样，返回true
        let {commentTitle,score,commentContent} = list[0];
        // 判断标题，评分，内容JSON比较是否一样
        if(list.slice(1).every(v=>{
          return v.commentTitle===commentTitle&&v.score===score&&
          (commentContent===v.commentContent||JSON.stringify(commentContent)===JSON.stringify(v.commentContent))
        })){
          return list[0]
        }else{
          return true
        }
      }else{
        // 不需要
        return list.length?list[0]:null
      }
      console.log(list.length)
    },
    // 跳转成长粒宣传页
    // detailIntroduce () {
    //   this.$router.push('/commentIntroduce');
    // },
    computedAinum(sumAi, numLen = 10000) {
      const newSum = sumAi > 0 ? sumAi : 0
      const minL = parseInt(newSum / numLen)
      if (minL < 1) {
          return newSum
      }
      return Math.floor(newSum / numLen * 10) / 10
    },
    async getTokenUsageApi_init() {
        const res = await this.$api.getTokenUsage()
        if (res.code === 200 && res.data) {
          const { remainTokenNum, tokenWarn } = res.data
          this.aiRemaining = remainTokenNum > 0
          this.tokenWarn = tokenWarn
          this.remainTokenNum = `${this.computedAinum(remainTokenNum)}${remainTokenNum >= 10000 ? '万' : ''}`
        }
    },
  },
  async created() {
    let params = this.$route.params;
    this.optype = this.$route.query.type || 'add';

    if (this.optype === 'add') {
      // 判断路由中的参数是否存在，如果没有存在则是页面刷新了，则获取缓存  begin
      if (params.courseArrangeId) {
        localStorage.setItem(`cacheComment`, JSON.stringify(params));
      } else {
        let cacheComment = localStorage.getItem(`cacheComment`);
        if (cacheComment) {
          params = JSON.parse(cacheComment);
        }
      }
      params.detail.className = params.detail.courseArrange.className;
      params.detail.curriculumName = params.detail.courseArrange.curriculumName;
      this.detail = params.detail;
      //   end
      this.stus = params.list;
      let date = new Date();
      let month = date.getMonth() + 1; // 月（注意月份从0开始，需要加1）
      let day = date.getDate(); // 日
      this.params.item = {
        commentContent: {
          list: [{ type: 'aitext', content: '' }],
        },
        commentScore: {
          id: '',
          score: 0,
          scoreType: 0,
        },
        commentTitle: month + '月' + day + '日的课堂点评',
      };
      // console.log(this.stus, '所选学生列表');
      if (this.stus.length > 1) {
        const resStu = await this.$api.commentCommentList({
          courseArrangeId: params.courseArrangeId,
          studentIds: this.stus.map(stu => {
            return stu.studentId;
          }),
        });
        if (resStu.code !== 200) {
          return;
        }
        // 更新stus
        this.stus = resStu.data.commentRecordList;
        // console.log(resStu);
        this.params.itemList = this.stus.map(stu => {
            return {
              commentContent: stu.commentContent || { list: [{ type: 'aitext', content: '' }] },
              commentRecordId: stu.id || '',
              commentScore: {
                id: stu.commentScoreId || '',
                score: stu.score || 0,
                scoreType: 0,
              },
              commentTitle: stu.id ? stu.commentTitle : month + '月' + day + '日的课堂点评',
              studentId: stu.studentId,
            };
          });
        this.currentStudentId = this.stus[0].studentId;
        this.currentStudentIndex = 0;

        // console.log(this.params.itemList, '初始化');
        let flag=this.checkAllStus();
        // 不要改成!flag 业务如此！！
        if(flag!==true){
          // 进概括点评
          if(flag!==null){
            this.params.item = {
              commentContent: flag.commentContent,
              commentScore: {
                id: '',
                score: flag.score,
                scoreType: 0,
              },
              commentTitle: flag.commentTitle,
            };
            this.params.itemList = this.stus.map(stu => {
              return {
                commentContent:{ list: [{ type: 'aitext', content: '' }] },
                commentRecordId: '',
                commentScore: {
                  id:  '',
                  score: 0,
                  scoreType: 0,
                },
                commentTitle:month + '月' + day + '日的课堂点评',
                studentId: stu.studentId,
              };
            });
          this.currentStudentId = this.stus[0].studentId;
          this.currentStudentIndex = 0;

          }
        }else{
          if (this.stus.some(v => v.commentRecordStatus === 0)) {
            this.isEveryComment = true;
          }
        }
        
      }

      this.params.studentIds = params.list.map(v => {
        // let obj = {
        //   studentId: v.studentId,
        // };
        // if (v.id) {
        //   obj = Object.assign({}, obj, {
        //     commentRecordId: v.id,
        //   });
        // }
        return v.studentId;
      });
      this.params.courseArrangeId = params.courseArrangeId;
      this.params.campusId = params.campusId;
      this.params.classId = params.classId;
      this.params.curriculumId = params.curriculumId;
      this.isBatch = params.isBatch;
      this.reviewEnable = params.reviewEnable;
    } else {
      this.id = this.$route.query.id;
      this.render();
    }
    // 添加精彩瞬间的事件监听
    this.$onBus('updateCommentMoment', list => {
      this.$refs.multInputRef.updateDataList(
        list.map(v => {
          return {
            type: 'moment',
            url: v.videoUrl,
            status: v.status,
            videoId: v.id,
          };
        })
      );
    });
    // 查询AI算力
    this.getTokenUsageApi_init()
  },
};
</script>

<style lang="scss" scoped>
.course-comment-edit {
  flex-direction: column;
  height: 100%;
  .aiGrowth {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    color: var(--c1);
    padding: var(--fs-xs) calc(var(--gap) * 15);
    background: var(--g1);
  }
  .main-container {
    background-color: var(--white);
    width: 100%;
  }
  .title {
    padding: calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 8) calc(var(--gap) * 16);
    color: var(--g6);
    font-size: 12px;

    .preview {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: var(--c1);
      float: right;
    }
  }
  .class-time {
    padding-left: calc(var(--gap) * 16);
    margin-bottom: calc(var(--gap) * 4);
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #646566;
    line-height: 16px;
  }
  .van-ellipsis {
    font-size: 14px;
    padding-left: calc(var(--gap) * 16);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #646566;
    line-height: 16px;
  }
  .every-switch {
    height: 26px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 16px;
    padding-right: 16px;
  }

  .comment-form {
    /deep/ .van-cell {
      // padding-bottom: 0px;
    }
    /deep/ .van-cell::after {
      border: none;
    }

    .comment-title {
      width: 100%;
      padding-left: 16px;
      padding-right: 16px;
      height: 48px;
      font-size: 16px;
      margin-top: 6px;
      font-family: PingFang SC, PingFang SC;
      // margin-bottom: 13px;
      font-weight: 500;
      color: #323233;
      /deep/ .van-cell {
        background-color: #f7f8fa;
        border-radius: 6px;
        line-height: 19px;
        height: 48px;
      }
    }
  }
  .students-tab {
    opacity: 1;
    overflow: hidden;
    height: 56px;
    margin-top: 12px;
    background-color: #f7f8fa;
    display: flex;
    align-items: center;
    transition: all 0.5s;
    .student-name {
      width: 100%;
      height: 100%;
      .point {
        width: 4px;
        height: 4px;
        border-radius: 4px;
        background-color: #69d395;
        position: absolute;
        right: 3px;
        top: 3px;
      }
    }
    /deep/ .van-tabs__wrap {
      height: 32px;
    }
    /deep/ .van-tabs__nav {
      background-color: #f7f8fa;
      padding-right: 16px;
      padding-left: 8px;
    }
    /deep/ .van-tab {
      margin-left: 8px;
      height: 32px;
      padding: 5px 8px 5px 8px;
      border-radius: 6px;
      background-color: white;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #323233;
      line-height: 19px;
    }
    /deep/ .van-tab--active {
      background-color: var(--c1);
      color: white;
    }
  }
  .students {
    height: 56px;
    width: 100%;
    background-color: #f7f8fa;
    .student-item {
      height: 32px;
      padding: 5px 8px 5px 8px;
      border-radius: 6px;
      background-color: white;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #323233;
      line-height: 19px;
    }
    .active-student {
      background-color: var(--c1);
      color: white;
    }
  }
  .btn-wrap {
    padding: 0 calc(var(--gap) * 16);
  }

  .qanda-wrapper {
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g6);
    padding-bottom: calc(var(--gap) * 32);
    .icon {
      margin-left: calc(var(--gap) * 4);
      margin-top: calc(var(--gap) * 2);
    }
  }

  .tips {
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    color: var(--g6);
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    background: var(--g1);
  }
}
.button-slot {
  flex: 1;
}
</style>
